import { PrimaryButton, SecondaryButton } from '@/components/Button';
import { Dialog } from '@/components/Dialog';
import { Input } from '@/components/ui/input';
import { useRef, useState } from 'react';
import CardForm from '../components/CardForm';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DeleteCard } from '@/service/overview';

export const useBilling = () => {
  const createCard = async () => {
    const res = await Dialog.info({
      dialogContentClassName: 'w-[540px] p-0 ',
      contentJSX: ({ onClose, resolve }) => {
        const formRef = useRef<{ handleSubmit: () => void }>(null);
        const [isLoading, setIsLoading] = useState(false);
        return (
          <form
            onSubmit={async (e) => {
              e.preventDefault();
              try {
                setIsLoading(true);
                await formRef?.current?.handleSubmit();
                toast.info('Add Payment Details success');
                // after createCard , stripe will call our server , may take some time, temporary solve by this way
                const TIME_TO_WAIT_STRIPE = 1000;
                setTimeout(() => {
                  resolve();
                }, TIME_TO_WAIT_STRIPE);

                onClose();
              } catch (error) {
                toast.error('Add card failed');
                // log
              } finally {
                setIsLoading(false);
              }
            }}
          >
            <div className="flex flex-col ">
              <h1 className="p-6 text-jen-content-primary text-[20px] leading-[24px]">Add Payment Details</h1>
              <div className="border-b border-jen-border-primary"></div>
              <div className="p-6 max-h-[calc(100vh-200px)] overflow-auto">
                <CardForm formRef={formRef} />
              </div>

              <div className="border-b border-jen-border-primary"></div>
              <div className="grid grid-cols-2 justify-between gap-2 p-6">
                <SecondaryButton className="h-[44px]" onClick={() => onClose()}>
                  Cancel
                </SecondaryButton>
                <PrimaryButton className="h-[44px]" disabled={isLoading} type="submit">
                  {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
                  Continue
                </PrimaryButton>
              </div>
            </div>
          </form>
        );
      },
    });
    return res;
  };
  const deleteCard = async ({ id }: { id: string }) => {
    const res = await Dialog.info({
      dialogContentClassName: ' p-0 ',
      contentJSX: ({ onClose, resolve }) => {
        const [isLoading, setIsLoading] = useState(false);
        return (
          <div className="flex flex-col ">
            <h1 className="p-6 text-jen-content-primary text-[20px] leading-[24px]">Delete Card</h1>
            <div className="text-[#747479] ml-6 mt-2">Are you sure you want to delete this card?</div>
            <div className="grid grid-cols-2 justify-between gap-2 p-6">
              <SecondaryButton className="h-[44px]" onClick={() => onClose()}>
                Cancel
              </SecondaryButton>
              <PrimaryButton
                isLoading={isLoading}
                onClick={async () => {
                  try {
                    setIsLoading(true);
                    await DeleteCard({ id });
                    onClose();
                    resolve();
                  } catch (error: any) {
                    toast.error(error.message || 'Delete card failed');
                  } finally {
                    setIsLoading(false);
                  }
                }}
                className="bg-[#bc3229] hover:bg-[#bc3229] h-[44px]"
                disabled={isLoading}
                type="submit"
              >
                {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
                Delete
              </PrimaryButton>
            </div>
          </div>
        );
      },
    });
    return res;
  };

  return {
    createCard,
    deleteCard,
  };
};
